import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import Home from './pages/Home.js';
import DeveloperPlatform from './pages/DeveloperPlatform.js';

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chat" element={<App />} />
        <Route path="/developers" element={<DeveloperPlatform />} />
      </Routes>
    </Router>
  );
}
